import React from "react";
import "./ThankYouPage.css";

const Nom035SecIResults = () => {
  return (
    <div className="thankyou-container">
      <h1 className="thankyou-title">¡Gracias por tu participación!</h1>
      <p className="thankyou-message">
        Has contestado correctamente Nom035 Guia I. Ya puedes cerrar esta ventana.
      </p>
      <button className="close-button" onClick={() => window.close()}>
        Cerrar ventana
      </button>
    </div>
  );
};

export default Nom035SecIResults;
